export default `
  fragment LanguageFragment on languages {
    id
    language
    code2
    code3
  }
`;
